/**
 * Map Page Config Access
 *
 * Reads the JSON blob rendered by snippets/map-config.liquid, which
 * carries section settings from the theme editor to the map components.
 */

export interface MapPageConfig {
  locationsUrl?: string;
  /** Email-list signup destination for sold-out / season-complete CTAs */
  signupUrl?: string | null;
  [key: string]: unknown;
}

let cachedConfig: MapPageConfig | null = null;

/**
 * Parse and cache the #map-config JSON
 *
 * @remarks
 * The element is server-rendered before any component mounts, so a
 * one-time parse is safe. Missing or malformed config yields an empty
 * object so callers can rely on optional access.
 */
export function getMapPageConfig(): MapPageConfig {
  if (cachedConfig) return cachedConfig;

  try {
    const element = document.getElementById("map-config");
    cachedConfig = JSON.parse(element?.textContent || "{}");
  } catch {
    cachedConfig = {};
  }

  return cachedConfig ?? {};
}
